import React, { useContext, createContext } from 'react';
import { useQuery } from 'urql';
import gql from 'graphql-tag';
import { graphql, useStaticQuery } from 'gatsby';
import { useSupportContext } from '../../../helpers/context-provider';
import { isObjectEmpty } from '../../../utils/is-object-empty';

const HomeContext = createContext();

export const HomeProvider = ({ children }) => {
  const supportContext = useSupportContext();
  const [articlesUpdate, setArticlesUpdate] = React.useState([]);
  const { isLoading } = supportContext;
  const {
    allStrapiVideo,
    allStrapiTopic,
    allStrapiArticle,
    supportcenter
  } = useStaticQuery(graphql`
    query StrapiHomeQuery {
      allStrapiVideo(sort: { fields: [updatedAt], order: DESC }) {
        edges {
          node {
            id
            video_name
            youtube_id
            uid
            updatedAt
            topic {
              topic_url
            }
          }
        }
      }
      allStrapiTopic {
        edges {
          node {
            topic_name
            topic_description
            id
            topic_url
            uid
          }
        }
      }
      allStrapiArticle {
        edges {
          node {
            article_name
            article_url
            id
            uid
            topic {
              id
              topic_url
            }
          }
        }
      }
      # offline/default data
      supportcenter {
        getSupportData {
          videos
          topics
          articles
        }
      }
    }
  `);

  const [
    { fetching: homeQueryFetching, data: homeQueryData = {}, error: homeQueryError }
  ] = useQuery({
    query: gql`
      query homeQuery {
        getSupportData {
          articles
          topics
          videos
        }
      }
    `,
    pause: isLoading
  });

  React.useEffect(() => {
    setArticlesUpdate(
      allStrapiArticle.edges
        .map((article) => (article?.node?.topic?.topic_url && article ))
        .filter((article) => article)
    );
  }, [allStrapiArticle.edges]);

  return (
    <HomeContext.Provider
      value={{
        ...supportContext,
        allStrapiVideo,
        allStrapiTopic,
        allStrapiArticle: {
          ...allStrapiArticle,
          edges: articlesUpdate
        },
        ...(!isObjectEmpty(homeQueryData) ? homeQueryData : supportcenter),
        isLoading: isLoading || homeQueryFetching
      }}
    >
      {children}
    </HomeContext.Provider>
  );
};

export const useHomeContext = () => {
  const context = useContext(HomeContext);
  if (!context || context === undefined)
    throw new Error('useHomeContext must be used within a HomeProvider');

  return context;
};
